// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","177":"home","180":"story"}[chunkId] || chunkId) + "-" + {"93":"21d2f63fb46cc8eca908","177":"a53818e310dd7063ee9b","180":"c1b1176fb6ce0b02b7b5","628":"19d13645795758613286"}[chunkId] + ".css";
};